// src/App.js
import React from 'react';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { ChatProvider } from './context/ChatProvider';
import Wrapper from './components/Wrapper';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n'; // Your i18n configuration file

// ==============================
// Global Styles
// ==============================
const GlobalStyle = createGlobalStyle`
    :root {
        --main-color-dark-palette: #3f4e55; /* Brand Gray */
        --secondry-color-dark-palette: rgba(63, 78, 85, 0.8); /* Transparent Brand Gray */
        --blue-button-color: #009fe3; /* Brand Blue */
        --blue-active-color: #007db7; /* Slightly darker Blue */
        --blue-gradient: linear-gradient(90deg, #009fe3 65%, #007db7 100%); /* Brand Gradient */
    }

    * {
        margin: 0;
        padding: 0;
        outline: transparent;
        text-decoration: none;
        box-sizing: border-box;
        font-family: 'Poppins', sans-serif;
    }

    body {
        background: var(--blue-gradient);
    }
`;

// ==============================
// Keyframe Animations
// ==============================

/**
 * Combined animation for moving, scaling, and rotating the background.
 * This creates a more dynamic and engaging effect.
 */
const animateBackground = keyframes`
    0% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }
    25% {
        transform: translate(50px, -30px) scale(1.1) rotate(5deg);
    }
    50% {
        transform: translate(-40px, 40px) scale(1.2) rotate(-5deg);
    }
    75% {
        transform: translate(30px, -50px) scale(1.1) rotate(3deg);
    }
    100% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }
`;

// ==============================
// Styled Components
// ==============================

/**
 * Animated Background Component
 * - Moves the background image across the screen.
 * - Scales the image to add depth.
 * - Rotates the image slightly for a dynamic effect.
 */
const Background = styled.div`
    position: fixed; /* Ensures the background covers the entire viewport */
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    z-index: -1;
    background: url('/images/bg.png') no-repeat center center; /* Ensure the image is in public/images/bg.png */
    background-size: cover;
    animation: ${animateBackground} 60s ease-in-out infinite;

    /* Optimize performance by hinting the browser */
    will-change: transform;
`;

// ==============================
// App Component
// ==============================

function App() {
    return (
        <>
            {/* Inject Global Styles */}
            <GlobalStyle />

            {/* Animated Background */}
            <Background />

            {/* Internationalization Provider */}
            <I18nextProvider i18n={i18n}>
                {/* Chat Context Provider */}
                <ChatProvider>
                    {/* Main Wrapper Component */}
                    <Wrapper />
                </ChatProvider>
            </I18nextProvider>
        </>
    );
}

export default App;
